<div class="container">
    <input type="checkbox"  (change)="onValueChange($event.target['checked'])" [checked]="initialValue">
    <span>This will allow you to enable and disable the sending of cookies to obtain images.</span>
</div>